// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopOrderItemListRequestModel from '../../model/get-shop-order-item-list-request-model';
import GetShopOrderItemListRequestDTO from '../dto/get-shop-order-item-list-request-dto';
import dtoSchema from '../schemas/get-shop-order-item-list-request-schema';

export default abstract class GetShopOrderItemListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopOrderItemListRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopOrderItemListRequestDTO>): GetShopOrderItemListRequestModel;
  static toModel(dto: DeepPartial<GetShopOrderItemListRequestDTO> | undefined | null): GetShopOrderItemListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopOrderItemListRequestDTO> | undefined | null): GetShopOrderItemListRequestModel | undefined {
    return dto ? new GetShopOrderItemListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopOrderItemListRequestModel> | GetShopOrderItemListRequestModel): GetShopOrderItemListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopOrderItemListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopOrderItemListRequestModel, can not map to GetShopOrderItemListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
